export function IOVThesholds () {
  return {
    fullAgreement: 0.4,
    partialAgreement: 0.7
  }
}
